const items = [
  "CLOSE PROTECTION",
  "LÉGION ÉTRANGÈRE — 2E REP",
  "RISK ASSESSMENT",
  "VIP PROTECTION",
  "CRISIS MANAGEMENT",
  "WORLDWIDE DEPLOYMENT",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div className="border-y border-[#28342C] bg-[#111613] py-5 overflow-hidden" data-testid="tactical-marquee">
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((t, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10 font-heading text-lg sm:text-xl font-bold uppercase tracking-[0.2em]">
                <span className={i % 2 === 0 ? "text-[#E6ECE8]" : "text-stroke"}>{t}</span>
                <span className="text-[#C8B48D] text-xs">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
